
<template>
  <div id="menutop">
    <!-- Fixed navbar -->
    <nav class="navbar navbar-expand-md navbar-light fixed-top bg-light">
        <a class="navbar-brand"
            v-bind:href="home_frontend_url()"
        >{{ app_title() }}</a>
        <img v-bind:src="server_base_url() + '/img/topnav_logo_45px_hoch.png'" height="45" class="rounded">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="nav navbar-nav">
                <router-link to="/uploadcover"
                    tag="li"
                    active-class="active"
                    class="nav-item"
                    exact><a class="nav-link">Upload</a></router-link>
                <router-link to="/cropme"
                    tag="li"
                    active-class="active"
                    class="nav-item"
                    ><a class="nav-link">Freigabe</a></router-link>
                <router-link to="/dispatcher"
                    tag="li"
                    active-class="active"
                    class="nav-item"
                    exact><a class="nav-link">Dispatcher</a></router-link>
                <router-link to="/admin"
                    tag="li"
                    active-class="active"
                    class="nav-item"
                    exact><a class="nav-link">Admin</a></router-link>
                <router-link to="/public"
                    tag="li"
                    active-class="active"
                    class="nav-item"
                    exact><a class="nav-link">Public-Bereich</a></router-link>
            </ul>
            <form class="form-inline mt-2 mt-md-0">
                <button class="btn btn-outline-success my-2 my-sm-0" type="button"
                    @click="abmelden">Abmelden</button>
            </form>
        </div>
    </nav>
  </div>
</template>

<script>
// Mixin fuer diese Komponente importieren
import commonvars from './mixins/commonvars.js';

export default {
  name: 'mycover',
  mixins: [
    commonvars
  ],
  methods: {
    abmelden() {
        localStorage.clear();
        this.$router.push("/login");
    },
    home_frontend_url() {
        return window.global_mycover.server_base_url + "/frontend";
    },
    uploadcovers_url() {
        return window.global_mycover.server_base_url + "/frontend/#/uploadcover";
    },
    cropme_dispatcher_url() {
        return window.global_mycover.server_base_url + "/frontend/#/cropme";
    }
  }
};
</script>

<style scoped>
.bg-light {
    background-color: #f4cb42 !important;
    }
</style>
